import { useMutation, useQueryClient } from "@tanstack/react-query";

import { onToast } from "@components/Toast";

import { chatAPI } from "@api/chat";
import { processRequest } from "@api/config";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";
import { NOTIFICATION_DURATION } from "@configs/constants";

export const useGetMutedUserListQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.MUTED_USERS_LIST],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_MUTED_USERS_LIST,
				request: (token) => chatAPI.getMutedUserListAsync({ token }),
			});

			return data;
		},
	});

export const useMuteUserByIdMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ userId, duration }: { userId: string; duration: number }) => {
			const { code, message } = await processRequest({
				prefix: API_PREFIXES.MUTE_USER_BY_ID,
				request: (token) => chatAPI.muteUserByIdAsync({ token, userId, duration }),
			});
			return { code, message };
		},
		onSuccess(data) {
			onToast({
				message: "Success",
				description: data.message,
				duration: NOTIFICATION_DURATION.SHORT,
			});
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MUTED_USERS_LIST] });
		},
	});
};

export const useUnmuteUserByIdMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ userId }: { userId: string }) => {
			await processRequest({
				prefix: API_PREFIXES.UNMUTE_USER_BY_ID,
				request: (token) => chatAPI.unMuteUserByIdAsync({ userId, token }),
			});
		},
		onSuccess() {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MUTED_USERS_LIST] });
		},
	});
};
